import { useEffect } from 'react';
import type {
  HydrogenShipperBookingOverviewPaginatedData,
  HydrogenShipperBookingOverviewRequestParams,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  params: HydrogenShipperBookingOverviewRequestParams;
} & OptionalUrlTemplate;

type RequestParams = {
  params: HydrogenShipperBookingOverviewRequestParams;
} & UrlTemplate;

export function useHydrogenShipperBookingOverview({ url, params }: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: RequestParams) =>
      axios.request<HydrogenShipperBookingOverviewPaginatedData>({
        ...baseConfig,
        url,
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  return request;
}

export type HydrogenShipperBookingOverviewRequest = ReturnType<
  typeof useHydrogenShipperBookingOverview
>;
